// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Tool } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconTool(props: any) {
    return <IconBase icon={Tool} {...props} />
  }

  export default IconTool
  